import { ActionIcon, Button, TextInput } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { useCallback, useEffect, useRef, useState } from "react";

import { Flex } from "../../../../styled";
import { getManagementSearchParams } from "./ManagementSearch.utils";

interface Props {
  section: string;
  refetch: (params: any) => void;
  currentRequestParams: any;
}

const ManagementSearch = ({
  section,
  refetch,
  currentRequestParams,
}: Props) => {
  const [searchParams, setSearchParams] = useState<Record<string, string>>({});
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [clearPosition, setClearPosition] = useState<"start" | "end">("end");

  const availableParams = getManagementSearchParams(section);

  useEffect(() => {
    const handleResize = () =>
      window.innerWidth >= 1200 && Object.keys(availableParams).length >= 4
        ? setClearPosition("start")
        : setClearPosition("end");
    window.addEventListener("resize", handleResize);
    handleResize(); // Call initially to set the correct position
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const onSearch = useCallback(
    (params: any) => {
      // refetch({ ...currentRequestParams, ...params });
      console.log(params);
    },
    [currentRequestParams, refetch],
  );

  const clearSendTimeout = () =>
    timeoutRef.current && clearTimeout(timeoutRef.current);

  useEffect(() => {
    clearSendTimeout();
    timeoutRef.current = setTimeout(() => {
      onSearch(searchParams);
    }, 500);

    return () => {
      clearSendTimeout();
    };
  }, [searchParams]);

  const handleManualSearch = () => {
    clearSendTimeout();
    onSearch(searchParams);
  };

  const handleClear = () => {
    setSearchParams(prev => {
      return Object.keys(prev).reduce((acc, key) => {
        acc[key] = "";
        return acc;
      }, {});
    });
  };

  const renderClearButton = () =>
    Object.values(searchParams).some(el => el !== "") && (
      <Button variant="outline" onClick={handleClear}>
        Clear
      </Button>
    );
  // DO NOT REMOVE- waiting for implementation!!!!!!!

  return null;
  // return (
  //   <Flex gap={10} wrap="wrap">
  //     {clearPosition === "start" && renderClearButton()}
  //     {Object.entries(availableParams).map(([key, value], index) => (
  //       <TextInput
  //         key={key}
  //         placeholder={value}
  //         style={{ minWidth: "150px" }}
  //         value={searchParams[key]}
  //         onChange={e =>
  //           setSearchParams({ ...searchParams, [key]: e.currentTarget.value })
  //         }
  //         onKeyDown={e => e.key === "Enter" && handleManualSearch()}
  //         rightSection={
  //           index === Object.entries(availableParams).length - 1 && (
  //             <ActionIcon onClick={handleManualSearch}>
  //               <IconSearch />
  //             </ActionIcon>
  //           )
  //         }
  //       />
  //     ))}
  //     {clearPosition === "end" && renderClearButton()}
  //   </Flex>
  // );
};
export default ManagementSearch;
